module.exports = ".action{\n  width: 10%;\n}\n\n.dropdown-menu{\n  left: unset;\n  right: 0;\n}\n\n.table-responsive{\n  overflow-x: unset;\n}\n\n.teams-title {\n  margin-top: 0;\n}\n\n::ng-deep .modal{\n  z-index: 4000;\n}\n\n.text-start {\n  text-align: start;\n}\n\n.branch-title {\n  font-weight: bold; \n}\n\n.branch-title.parent-team {\n  margin-top: 15px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/teams/teams.component.css
// module id = ./src/app/main-settings/teams/teams.component.css
// module chunks = main